import { Button } from "src/components/ui/Button";
import { Link } from "react-router-dom";
import { ROUTES } from "src/routes/RouteConfig";

const CtaSection = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="w-full relative z-10">
        <div className="relative bg-gradient-to-br from-rfpurple-900 via-rfpurple-800 to-rfpurple-700 rounded-none shadow-2xl overflow-hidden" style={{ boxShadow: '0 -25px 50px -12px rgba(0, 0, 0, 0.25), 0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between px-8 py-12 sm:px-16 sm:py-20 gap-12 lg:gap-16 relative z-10 max-w-7xl mx-auto">
            <div className="flex-1 min-w-0">
              <div className="mb-6">

                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-4 leading-tight">
                  Ready to{" "}
                  <span className="relative inline-block">
                    <span className="relative z-10 bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">
                      reinforce
                    </span>
                    <div className="absolute -bottom-2 left-0 w-full h-3 bg-gradient-to-r from-yellow-400/30 to-orange-400/30 rounded-full blur-sm"></div>
                  </span>{" "}
                  your learning?
                </h2>
                <p className="text-xl sm:text-2xl text-white/90 font-medium mb-6">
                  Join rfLearn today and transform how you learn.
                </p>
              </div>
              <div className="flex flex-wrap gap-4 text-white/80 text-base">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></div>
                  AI-Powered Learning
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-blue-400 rounded-full mr-2 animate-pulse delay-300"></div>
                  Expert Human Tutors
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-purple-400 rounded-full mr-2 animate-pulse delay-700"></div>
                  Personalized Experience
                </div>
              </div>
            </div>
            
            <div className="flex flex-col w-full max-w-sm mx-auto lg:mx-0 lg:w-auto space-y-4">
              <Button className="group relative overflow-hidden w-full px-10 py-6 text-lg font-bold bg-gradient-to-r from-white to-gray-50 text-rfpurple-800 hover:from-yellow-50 hover:to-orange-50 shadow-xl transition-all duration-300 border-2 border-white/20 focus:ring-4 focus:ring-white/30 rounded-2xl transform hover:scale-105 hover:shadow-2xl" asChild>
                <Link to={ROUTES.BECOME_TUTOR.path}>
                  <span className="relative z-10 flex items-center justify-center">
                    <svg className="w-5 h-5 mr-2 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                    Become a Tutor
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-orange-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                </Link>
              </Button>
              
              <Button className="group relative overflow-hidden w-full px-10 py-6 text-lg font-semibold bg-transparent text-white border-2 border-white/30 hover:border-white/50 hover:bg-white/10 shadow-lg transition-all duration-300 focus:ring-4 focus:ring-white/20 rounded-2xl transform hover:scale-105 backdrop-blur-sm" asChild>
                <Link to={ROUTES.BOOK_DEMO.path}>
                  <span className="relative z-10 flex items-center justify-center">
                    <svg className="w-5 h-5 mr-2 transition-transform group-hover:rotate-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                    Request a Demo
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                </Link>
              </Button>
              
              <p className="text-center text-white/60 text-sm mt-4">
                No credit card required
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;